import {
  CookieAuthenticationCredential,
  CookieAuthenticationCredentialConfiguration,
} from './CookieAuthenticationCredential';

// @ts-ignore
globalThis.sasAuthBrowser = {
  createCookieAuthenticationCredential(config: CookieAuthenticationCredentialConfiguration) {
    return new CookieAuthenticationCredential(config);
  },
};
